import { TextWithMaskInput } from "components/Inputs"
import { Switch } from "components/Inputs"
import { Row, Col, Button } from "react-bootstrap"

export const Filtros = ({ filtros }) =>
{
    if (!filtros || filtros.length <= 0) { return <></> }

    return (
        <div className="w-100">
            <hr />
            <div className="d-flex justify-content-around w-100">
                {filtros.map(filtro => <div key={filtro.props.placeHolder}>{filtro}</div>)}
            </div>
            <hr />
        </div>
    )
}

export const FiltroTexto = ({ label, placeHolder, mask, onBlur, name, value }) =>
{
    return (
        <TextWithMaskInput Label={label} Placeholder={placeHolder} Mask={mask} OnBlur={onBlur} Name={name} Value={value}></TextWithMaskInput>
    )
}

export const FiltroNumProc = ({handleFilterChange, defaultVal}) =>
{
    return (
        <FiltroTexto label={"Número do processo"} placeHolder={"00.000"} 
                     onBlur={(event) => { handleFilterChange(event) }}
                     name={"numProc"} value={defaultVal} />
    )
}

export const FiltroTipoDoc = ({handleFilterChange, defaultVal}) =>
{
    return (
        <FiltroTexto label={"Tipo de documento"} placeHolder={"Alvara"} 
                     onBlur={(event) => { handleFilterChange(event) }} 
                     name={"tipoDocumento"} value={defaultVal} />
    )
} 

export const FiltroNomeProprietario = ({handleFilterChange, defaultVal}) =>
{
    return (
        <FiltroTexto label={"Nome do proprietário"} placeHolder={"Fulano da Silva"} 
                     onBlur={(event) => { handleFilterChange(event) }} 
                     name={"nomeProprietario"} value={defaultVal} />
    )
} 

export const FiltroInscCadastral = ({handleFilterChange, defaultVal}) =>
{
    return (
        <FiltroTexto label={"Inscrição cadastral"} placeHolder={"00.00.000.0000.00.000"} 
                     onBlur={(event) => { handleFilterChange(event) }} 
                     name={"inscCadastral"} value={defaultVal} />
    )
} 

export const FiltroAnalista = ({handleFilterChange, defaultVal}) =>
{
    return (
        <FiltroTexto label={"Analista"} placeHolder={"Fulano da Silva"} 
                     onBlur={(event) => { handleFilterChange(event) }} 
                     name={"nomeAnalista"} value={defaultVal} />
    )
} 

export const FiltroDataCriacao = ({handleFilterChange, defaultVal}) =>
{
    return (
        <FiltroTexto label={"Data de criação"} placeHolder={"dd/mm/aaaa"} 
                     mask={"99/99/9999"} onBlur={(event) => { handleFilterChange(event) }} 
                     name={"dataCriacao"} value={defaultVal}/>
    )
}

export const FiltroMostrarParticipo = ({handleSwitchParticip, defaultVal}) =>
{
    return (
        <Switch Name={"particip"} Label={"Ver apenas os que faço parte"} 
                OnChange={handleSwitchParticip}  
                DefaultChecked={defaultVal} />)
}

export const ButtonFiltrar = ({handleFiltrarClick}) =>
{
    return (
        <Button onClick={handleFiltrarClick}>Filtrar</Button>
    )
}

export const FiltrosTabelaProcessos = ({handleFilterChange, handleFiltrarClick, handleSwitchParticip, filterVals}) =>
{
    return(
        <>
            <Row>
                <FiltroMostrarParticipo handleSwitchParticip={handleSwitchParticip} defaultVal={filterVals['particip'] !== ""} />
            </Row>
            <Row>
                <Col><FiltroNumProc handleFilterChange={handleFilterChange} defaultVal={filterVals['numProc']} /></Col>
                <Col><FiltroTipoDoc handleFilterChange={handleFilterChange} defaultVal={filterVals['tipoDocumento']} /></Col>
                <Col><FiltroNomeProprietario handleFilterChange={handleFilterChange} defaultVal={filterVals['nomeProprietario']} /></Col>
                <Col><FiltroInscCadastral handleFilterChange={handleFilterChange} defaultVal={filterVals['inscCadastral']} /></Col>
                <Col><FiltroAnalista handleFilterChange={handleFilterChange} defaultVal={filterVals['nomeAnalista']} /></Col>
                <Col><FiltroDataCriacao handleFilterChange={handleFilterChange} defaultVal={filterVals['dataCriacao']} /></Col>
            </Row>
            <Row>
                <ButtonFiltrar handleFiltrarClick={handleFiltrarClick} />
            </Row>
        </>
    )
}

export const FiltroSwitch = () =>
{
    return (
        <div>Filtro</div>
    )
}